export const SET_USER_PROCESSING = 'SET_USER_PROCESSING'
export const SET_USER_TO_NEW_USER = 'SET_USER_TO_NEW_USER'
export const GET_USER_BY_UUID = 'GET_USER_BY_UUID'
export const GET_USER_LAST_TRANSACTION = 'GET_USER_LAST_TRANSACTION'
export const SET_USER_LAST_TRANSACTION = 'SET_USER_LAST_TRANSACTION'
export const GET_USER_GCSI_SUBSCRIPTION = 'GET_USER_GCSI_SUBSCRIPTION'
export const SET_USER_GCSI_SUBSCRIPTION = 'SET_USER_GCSI_SUBSCRIPTION'
export const SET_USER = 'SET_USER'
export const SET_PROFILES = 'SET_PROFILES'
export const RESET_USER_BLOCK = 'RESET_USER_BLOCK'
export const RESET_USER_BLOCK_SUCCESS = 'RESET_USER_BLOCK_SUCCESS'
export const RESET_USER_BLOCK_ERROR = 'RESET_USER_BLOCK_ERROR'
export const SET_USER_FIELD = 'SET_USER_FIELD'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const SET_USER_FIELD_VALIDATION_ERROR = 'SET_USER_FIELD_VALIDATION_ERROR'
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR'
export const UPDATE_USER_ENTITLEMENT = 'UPDATE_USER_ENTITLEMENT'
export const UPDATE_USER_ENTITLEMENT_ERROR = 'UPDATE_USER_ENTITLEMENT_ERROR'
export const UPDATE_USER_ENTITLEMENT_SUCCESS = 'UPDATE_USER_ENTITLEMENT_SUCCESS'
export const CREATE_USER_ENTITLEMENT = 'CREATE_USER_ENTITLEMENT'
export const CREATE_USER_ENTITLEMENT_ERROR = 'CREATE_USER_ENTITLEMENT_ERROR'
export const CREATE_USER_ENTITLEMENT_SUCCESS = 'CREATE_USER_ENTITLEMENT_SUCCESS'
export const GET_USER_BY_UID = 'GET_USER_BY_UID'
export const GET_USER_BY_GCSI_USER_UUID = 'GET_USER_BY_GCSI_USER_UUID'
export const SET_USER_ERROR = 'SET_USER_ERROR'
export const CLEAR_USER_ENTITLEMENTS = 'CLEAR_USER_ENTITLEMENTS'
export const SIMULATION_SET_DATA = 'SIMULATION_SET_DATA'
export const SIMULATION_ERROR = 'SIMULATION_ERROR'
export const SIMULATE_USER = 'SIMULATE_USER'
export const ANONYMIZE_USER_DATA = 'ANONYMIZE_USER_DATA'
export const ANONYMIZE_USER_DATA_SUCCESS = 'ANONYMIZE_USER_DATA_SUCCESS'
export const ANONYMIZE_USER_DATA_ERROR = 'ANONYMIZE_USER_DATA_ERROR'
export const GRANT_USER_BONUS = 'GRANT_USER_BONUS'
export const GRANT_USER_BONUS_SUCCESS = 'GRANT_USER_BONUS_SUCCESS'
export const GRANT_USER_BONUS_ERROR = 'GRANT_USER_BONUS_ERROR'
export const GET_USER_HISTORY_DATA = 'GET_USER_HISTORY_DATA'
export const SET_USER_HISTORY_DATA = 'SET_USER_HISTORY_DATA'
export const UPDATE_USER_HISTORY_DATA = 'UPDATE_USER_HISTORY_DATA'
export const SET_USER_HISTORY_PROCESSING = 'SET_USER_HISTORY_PROCESSING'
export const CHANGE_ACCOUNT_OWNER = 'CHANGE_ACCOUNT_OWNER'
export const CHANGE_ACCOUNT_OWNER_SUCCESS = 'CHANGE_ACCOUNT_OWNER_SUCCESS'
export const CHANGE_ACCOUNT_OWNER_ERROR = 'CHANGE_ACCOUNT_OWNER_ERROR'

export function simulateUser (uid) {
  return {
    type: SIMULATE_USER,
    payload: { uid },
  }
}

export function setSimulationError (storeKey) {
  return {
    type: SIMULATION_ERROR,
    payload: { storeKey },
  }
}

export function setSimulationData ({ storeKey, value, path }) {
  return {
    type: SIMULATION_SET_DATA,
    payload: { storeKey, value, path },
  }
}

export function setUserProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserToNewUser ({ storeKey }) {
  return {
    type: SET_USER_TO_NEW_USER,
    payload: { storeKey },
  }
}

export function getUserByUid ({ storeKey, uid }) {
  return {
    type: GET_USER_BY_UID,
    payload: { storeKey, uid },
  }
}

export function getUserByGcsiUserUuid ({ storeKey, gcsiUserUuid }) {
  return {
    type: GET_USER_BY_GCSI_USER_UUID,
    payload: { storeKey, gcsiUserUuid },
  }
}

export function getUserGcsiSubscription ({ storeKey, gcsiUserUuid }) {
  return {
    type: GET_USER_GCSI_SUBSCRIPTION,
    payload: { storeKey, gcsiUserUuid },
  }
}

export function setUserGcsiSubscription ({ storeKey, data }) {
  return {
    type: SET_USER_GCSI_SUBSCRIPTION,
    payload: { storeKey, data },
  }
}

export function getUserLastTransaction ({ storeKey, uid }) {
  return {
    type: GET_USER_LAST_TRANSACTION,
    payload: { storeKey, uid },
  }
}

export function setUserLastTransaction ({ storeKey, data }) {
  return {
    type: SET_USER_LAST_TRANSACTION,
    payload: { storeKey, data },
  }
}

export function setUser ({ storeKey, data }) {
  return {
    type: SET_USER,
    payload: { storeKey, data },
  }
}

export function setProfiles (data) {
  return {
    type: SET_PROFILES,
    payload: data,
  }
}

export function setUserError ({ storeKey, error }) {
  return {
    type: SET_USER_ERROR,
    payload: { storeKey, error },
  }
}

export function getUserByUuid ({ storeKey, uuid }) {
  return {
    type: GET_USER_BY_UUID,
    payload: { storeKey, uuid },
  }
}

export function resetUserBlock ({ storeKey, uuid }) {
  return {
    type: RESET_USER_BLOCK,
    payload: { storeKey, uuid },
  }
}

export function resetUserBlockSuccess ({ storeKey, data, uuid }) {
  return {
    type: RESET_USER_BLOCK_SUCCESS,
    payload: { storeKey, data, uuid },
  }
}

export function resetUserBlockError ({ storeKey, error, uuid }) {
  return {
    type: RESET_USER_BLOCK_ERROR,
    payload: { storeKey, error, uuid },
  }
}

export function createUser ({ storeKey, data }) {
  return {
    type: CREATE_USER,
    payload: { storeKey, data },
  }
}

export function createUserSuccess ({ storeKey, data }) {
  return {
    type: CREATE_USER_SUCCESS,
    payload: { storeKey, data },
  }
}

export function createUserError ({ storeKey, error }) {
  return {
    type: CREATE_USER_ERROR,
    payload: { storeKey, error },
  }
}

export function clearUserError () {
  return {
    type: CLEAR_USER_ERROR,
  }
}

export function updateUser ({ storeKey, data }) {
  return {
    type: UPDATE_USER,
    payload: { storeKey, data },
  }
}

export function updateUserSuccess ({ storeKey, data }) {
  return {
    type: UPDATE_USER_SUCCESS,
    payload: { storeKey, data },
  }
}

export function updateUserError ({ storeKey, error }) {
  return {
    type: UPDATE_USER_ERROR,
    payload: { storeKey, error },
  }
}

export function updateUserEntitlement ({ storeKey, data }) {
  return {
    type: UPDATE_USER_ENTITLEMENT,
    payload: { storeKey, data },
  }
}

export function updateUserEntitlementError ({ storeKey, error }) {
  return {
    type: UPDATE_USER_ENTITLEMENT_ERROR,
    payload: { storeKey, error },
  }
}

export function updateUserEntitlementSuccess ({ storeKey, data }) {
  return {
    type: UPDATE_USER_ENTITLEMENT_SUCCESS,
    payload: { storeKey, data },
  }
}

export function createUserEntitlement ({ storeKey, data }) {
  return {
    type: CREATE_USER_ENTITLEMENT,
    payload: { storeKey, data },
  }
}

export function createUserEntitlementError ({ storeKey, error }) {
  return {
    type: CREATE_USER_ENTITLEMENT_ERROR,
    payload: { storeKey, error },
  }
}

export function createUserEntitlementSuccess ({ storeKey, data }) {
  return {
    type: CREATE_USER_ENTITLEMENT_SUCCESS,
    payload: { storeKey, data },
  }
}

export function clearUserEntitlements ({ storeKey }) {
  return {
    type: CLEAR_USER_ENTITLEMENTS,
    payload: { storeKey },
  }
}

export function anonymizeUserData ({ storeKey, data }) {
  return {
    type: ANONYMIZE_USER_DATA,
    payload: { storeKey, data },
  }
}

export function anonymizeUserDataSuccess ({ storeKey, data }) {
  return {
    type: ANONYMIZE_USER_DATA_SUCCESS,
    payload: { storeKey, data },
  }
}

export function anonymizeUserDataError ({ storeKey, error }) {
  return {
    type: ANONYMIZE_USER_DATA_ERROR,
    payload: { storeKey, error },
  }
}

export function grantUserBonusData ({ storeKey, data }) {
  return {
    type: GRANT_USER_BONUS,
    payload: { storeKey, data },
  }
}

export function grantUserBonusDataSuccess ({ storeKey, data }) {
  return {
    type: GRANT_USER_BONUS_SUCCESS,
    payload: { storeKey, data },
  }
}

export function grantUserBonusDataError ({ storeKey, error }) {
  return {
    type: GRANT_USER_BONUS_ERROR,
    payload: { storeKey, error },
  }
}
export function setUserHistoryProcessing (options = {}) {
  const { processing = true } = options
  return {
    type: SET_USER_HISTORY_PROCESSING,
    payload: {
      processing,
    },
  }
}

export function getUserHistoryData (options = {}) {
  const { page = 0 } = options
  return {
    type: GET_USER_HISTORY_DATA,
    payload: {
      page,
    },
  }
}

export function setUserHistoryData (options = {}) {
  const { data, processing = false } = options
  return {
    type: SET_USER_HISTORY_DATA,
    payload: {
      processing,
      data,
    },
  }
}

export function updateUserHistoryData (options = {}) {
  const { data, processing = false } = options
  return {
    type: UPDATE_USER_HISTORY_DATA,
    payload: {
      processing,
      data,
    },
  }
}

export function changeAccountOwner ({
  storeKey,
  accountId,
  newOwnerUid,
  sendPasswordResetEmail,
  moveZuoraSubscription,
  moveEntitlements,
}) {
  return {
    type: CHANGE_ACCOUNT_OWNER,
    payload: {
      storeKey,
      accountId,
      newOwnerUid,
      sendPasswordResetEmail,
      moveZuoraSubscription,
      moveEntitlements,
    },
  }
}

export function changeAccountOwnerSuccess ({ storeKey, data }) {
  return {
    type: CHANGE_ACCOUNT_OWNER_SUCCESS,
    payload: { storeKey, data },
  }
}

export function changeAccountOwnerError ({ storeKey, error }) {
  return {
    type: CHANGE_ACCOUNT_OWNER_ERROR,
    payload: { storeKey, error },
  }
}
